<template>
    <div>
        <PageTitle v-bind:title="title" v-bind:admin="false" />
        <TheCoursesMenu v-bind:index=3 />


        <QuoteTest />

        <h2 class="mt-4">Пройденные курсы</h2>

        <div class="alert alert-danger" v-if="errors.load">
            {{ errors.load }}
        </div>

        <Loader v-if="loading" />
        <div v-else>
            





<div class="row row-cols-1 row-cols-md-3 g-4">
    <div v-for="item in data.courses" v-bind:key="item.id" class="col mt-2">
        <div class="card h-100">
            <div style="height: 200px; background-size: cover;" v-bind:style="{ 'background-image': 'url(' + item.image + ')' }">
            </div>
            <div class="card-body">
                <h5 class="card-title"><router-link :to="{ name: 'course_show', params: { id: item.id } }">{{item.name}}</router-link>&nbsp;</h5>
                <div class="card-text">
                    <div class="card__rating">
                        <span :class="{'card__rating--filled' : item.rating >= 1}">☆</span>
                        <span :class="{'card__rating--filled' : item.rating >= 2}">☆</span>
                        <span :class="{'card__rating--filled' : item.rating >= 3}">☆</span>
                        <span :class="{'card__rating--filled' : item.rating >= 4}">☆</span>
                        <span :class="{'card__rating--filled' : item.rating >= 5}">☆</span>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <small class="text-muted">
                    <!-- Last updated 3 mins ago -->
                    <p class="m-0">Начат: {{ localeDate(item.pivot.started_at) }}</p>
                    <p class="m-0">Закончен: {{ localeDate(item.pivot.finished_at) }}</p>

                </small>
            </div>
        </div>
    </div>
</div>







            <!-- <TestCards /> -->
        </div>

        
    </div>
</template>

<script>
import TheCoursesMenu from '@/components/TheCoursesMenu'
import PageTitle from '@/components/PageTitle'
import Loader from '@/components/Loader'
// import TestCards from '@/components/TestCards'
import QuoteTest from '@/components/QuoteTest'
import axios from 'axios'

// import axios from 'axios'
export default {
    data() {
        return {
            data: [],
            title: 'Курсы',
            loading: true,
            errors: {load: ''},
        }
    },
    async mounted() {
        // загрузка данных:
        this.loadRecords()
    },
    methods: {
        async loadRecords() {
            this.errors.load = ''
            try {
                this.loading = true
                let response = await axios.get('courses/done')
                this.data = response.data
                this.loading = false
            }
            catch (e) {
                this.errors.load = 'Ошибка при загрузке данных'
            }

        },
        localeDate(d) {
            // Конвертируем число в строку. Для этого существуют специальные методы
            // toLocaleDateString() или toLocaleString() или toLocaleTimeString()
            // Итоговая строка будет зависеть от локализации системы пользователя. 
            // Для русской локали это будет "01.02.2020", 
            // для американской "2/1/2020", 
            // для немецкой — "1.2.2020"
            // Вы НЕ должны устанавливать формат даты самостоятельно
            if (d)
                return (new Date(d)).toLocaleDateString() 
            else
                return null;
        },

    },
    components: {
        TheCoursesMenu,
        PageTitle,
        Loader,
        // TestCards,
        QuoteTest,
    }
}
</script>



<style  scoped>
.card__rating {
  color: orange;
}

.card__rating > span {
  font-size: 30px;
  line-height: .5;
}

.card__rating--filled:before {
  content: "\2605";
  position: absolute;
}

</style>